import React, { Fragment, useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import swal from 'sweetalert';
import axios from "axios";
import { Badge } from "react-bootstrap";
import { IMAGES, SVGICON } from '../../src/jsx/constant/theme';
import Cars from '../components/cars';
import { useParams } from 'react-router-dom';
import useRef from "react";
import {
  Row,
  Col,
  Card,
  Popover,
  Tooltip,
  OverlayTrigger,
  Button,
} from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Tab, Nav, ListGroup } from "react-bootstrap";
 import { Modal } from 'react-bootstrap';
import { First } from 'react-bootstrap/esm/PageItem';

const messageBlog = [
  { id: '01' }, { id: '02' }, { id: '03' }, { id: '04' }, { id: '05' },
  { id: '06' }, { id: '07' }, { id: '08' }, { id: '09' }, { id: '10' },
  { id: '11' }, { id: '12' }, { id: '13' }, { id: '14' }, { id: '15' },
  { id: '16' }, { id: '17' }, { id: '18' }, { id: '19' }, { id: '20' },
  { id: '21' }, { id: '22' }, { id: '23' }, { id: '24' }, { id: '25' },
  { id: '26' }, { id: '27' }, { id: '28' }, { id: '29' }, { id: '30' }
];

const Orders = forwardRef((props, ref) => {
  const navigate = useNavigate();

  const { CustomerID } = useParams(); // Extract CustomerID from the URL
  const [startDate, setStartDate] = useState(new Date());
  const [inviteModal, setInviteModal] = useState("hidden");
  const [inviteModal1, setInviteModal1] = useState(true);
  const [listItem, setlistItem] = React.useState([])
  const [listItem1, setlistItem1] = useState([])
  const [popupModal, setpopupModal] = useState(false);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    // Fetch data for the given CustomerID
    fetch(`https://subk.education.com.ly/back/api/customers/${CustomerID}`)
      .then((response) => response.json())
      .then((data) => setOrders(data))
      .catch((error) => console.error('Error fetching orders:', error));
  }, [CustomerID]);
  useImperativeHandle(ref, () => ({
    showInviteModal() {
      setInviteModal("hidden")
      setInviteModal1(true)

    }
  }));
  const location = useLocation();
  const location2 = useLocation();
  const [itemName, setItemName] = useState('');

  const [cName, setCName] = useState('');
  const [last, setlast] = useState(0)
  console.log("Location search:", orders.vehicles);
   const searchParamscoust = new URLSearchParams(location2.search);
   const receivedDataArrayss = JSON.parse(searchParamscoust.get('data')) || [];

   const receivedcoustId = searchParamscoust.get('id') || '';
   const receivedcoustname= searchParamscoust.get('cname') || '';
  const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
  console.log('fffffff', receivedDataArrayss)

  // Parse the JSON string back to an array
  const userPermissions = JSON.parse(userPermissionsJSON);
  // Function to search for permissions for a specific page
  function getActionsForPage(pageName) {
    // Find the permissions object for the given page
    const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
  console.log('actionsForPage',pagePermissions); 
  
    // If permissions for the page are found, return the actions
    if (pagePermissions) {
        return pagePermissions.action;
    } else {
   navigate('/dashboard_1')
  
        return [];
    }
  }
  
  // Usage
  const pageName = 'Orders';
  const actionsForPage = getActionsForPage(pageName);

  const [data, setData] = useState([])
  const [qun, setQun] = useState(0)
  const [data1, setData1] = useState([])
  const [total, setTotal] = useState(0)
  const [atbak, setAtbak] = useState([])
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetch(`https://subk.education.com.ly/back/api/invoices/repair-order/${CustomerID}`) // Replace with your actual API endpoint
        .then((response) => response.json())
        .then((data) => {
            setInvoices(data);

            // Dynamically assign colors based on RepairOrderID
            const uniqueIds = [...new Set(data.map((item) => item.RepairOrderID))];
            const newColorMap = {};
            uniqueIds.forEach((id, index) => {
                newColorMap[id] = colors[index % colors.length]; // Cycle through the colors
            });
            setColorMap(newColorMap);
        })
        .catch((error) => console.error("Error fetching invoices:", error));
}, [CustomerID]);
  


  const showInviteModal1 = () => {

    setInviteModal1(false)
    setInviteModal("Block")
  }
  const notifyInfo = () => {
    swal({
      title: "هل متاكد من الغاء هده العملية",
      text:
        "بمجرد الضفظ على نعم سيتم اعادة توجيهك الى الصفحه الرئيسية",
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      dangerMode: true,
      confirmButtonAriaLabel: 'نعم',
      cancelButtonText: "العودة",
    }).then((willDelete) => {
      if (willDelete) {
        navigate('/dashboard_1')
      } else {
        setInviteModal(false)
      }
    })

  }

  const handleDelete = (index) => {
    // Create a copy of the list
    const updatedList = [...listItem];

    // Remove the item at the specified index
    updatedList.splice(index, 1);
    const totalAA = updatedList.reduce((total, item) => total + item.aa, 0);
    setTotal(totalAA);
    // Update the state with the new list
    setlistItem(updatedList);
  };

  const [colorMap, setColorMap] = useState({}); // Map for RepairOrderID to colors
  const colors = ["#f8d7da", "#d4edda", "#cce5ff", "#fff3cd", "#e2e3e5"];
  const [catigorydata, setCatigorydata] = useState([])
  const input = document.querySelector('input[name="city"]');
  if (input) {
    input.addEventListener('invalid', function (event) {
      if (event.target.validity.valueMissing) {
        event.target.setCustomValidity('الرجاء ادخال  القيمة');
      }
    })

    input.addEventListener('change', function (event) {
      event.target.setCustomValidity('');
    })
  }
  
 

 

 
  const [activeTab, setActiveTab] = useState('tools');
 
  

   
  const [errors, setErrors] = useState('')


 
  const [Name, setName] = useState('');
  const [ItemPrice, setItemPrice] = useState('');
  const [ItemID, setItemID] = useState('');
  const [TItemID, setTItemID] = useState('');
  const [TName, setTName] = useState('');
  const [TabakName, setTabakName] = useState('');
  const [AtbakID, setAtbakID] = useState('');
  const [FoodCategoryID, setFoodCategoryID] = useState('');


   
  // const queryString = new URLSearchParams({ data: JSON.stringify(listItem) }).toString();

  const [city, setCity] = useState([])
console.log('listItemlistItemlistItemlistItem',listItem)
  const queryString = new URLSearchParams({
    data: JSON.stringify(listItem),
    id: last.toString(),
    cname:cName,
    //total:total,

  }).toString();
    console.log('queryString', queryString)

 
  const userdata = localStorage.getItem('USER_data');
  const userData = JSON.parse(userdata);
    const userid = userData.id;
  const [customers, setCustomers] = useState({
    CustomerID: '',
    CustomerName: '',
    Notes: 'ww',
    AreaID: '',
    PhoneNumber: '',
    PhoneNumber1: '22',
    PhoneNumber2: '11',
    UserID: userid,
  });
  
 

  //CustomerID 	CustomerName 	Notes 	AreaID 	PhoneNumber 	PhoneNumber1 	PhoneNumber2 	UserID
 /*  const createintitem = async (e) => {
    e.preventDefault();
     if (!customers.PhoneNumber.match(/^(218)?09[123456][0-9]{7}$/) || !customers.PhoneNumber1.match(/^(218)?09[123456][0-9]{7}$/)
    ||!customers.PhoneNumber2.match(/^(218)?09[123456][0-9]{7}$/)) {
   
setErrors('رقم الهاتف  : 00 00 000 091 او 00 00 000 092')
console.log(errors)
   }
else{
    await axios.post('https://subk.education.com.ly/back/api/customers', customers).then(({ data }) => {
      setlast(data.CustomerID)
    setCName(data.CustomerName)
    console.log('last in', data.CustomerID)

  })
      .catch(function (error) {
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log('Error', error.message);
        }
        console.log(error.config);
      });
    //getfooditeming(Name);
   // getLastCustomer();
   // console.log('last', last)
    setInviteModal1(false)

  }}*/
  
  
  
  const cardBlog = [
    {svg:<i class="fa-solid fa-address-card" style={{color: 'green'}}></i>, number: `${orders.FirstName || ''} ${orders.LastName || ''}` , title:orders.Phone, changetheme:'success'},
 ]; 
 const netwrokBlog = [
  {image:IMAGES.dribble, title:'Dribble', price:'12,348', bg:'primary' , percent:'+36' },
  {image:IMAGES.facebook, title:'Facebook', price:'10,048', bg:'danger' , percent:'+33' },
  {image:IMAGES.instagram, title:'Instagram', price:'09,059', bg:'info' , percent:'-10' },
 
];
  return (

    <>
    <div className="" id="exampleModal1" style={{ visibility: { inviteModal } }} centered>

      <div className="container-fluid " style={{padding:'0.500rem'}}>
      <div className="row">
                    {cardBlog.map((item, ind)=>(
                        <div className="col-xl-12" key={ind}>
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className={`icon-box icon-box-lg rounded-circle bg-${item.changetheme}-light`} >
                                            {item.svg}               
                                        </div>
                                        <div className="total-projects ms-3">
                                            <h6 className={`count text-${item.changetheme}`}>{item.number}</h6> 
                                            <span>{item.title}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                 
                  
                </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="card mb-0 h-auto">
              <div className="card-body p-0">
              
                <div className="row gx-0">
                  <div className="col-xl-12 col-xxl-12 col-lg-12">
                  <div className="dlab-scroll  pt-3 ps-2">
               
                    <Tab.Container defaultActiveKey={'tools'}>
                      <div role="toolbar" className="toolbar ms-1 ms-sm-0">
                        <div className="saprat">
                          <div className="d-flex align-items-center">

                            <Nav as="ul" className="nav nav-pills" id="pills-tab" role="tablist">
                             
                            <Nav.Item as="li" className="nav-item btn-group" role="presentation">
                                <Nav.Link as="button" eventKey={'tools'} type="button" className="btn effect mx-2 nav-link" id="pills-home-tab" >
                                <i class="fa-solid fa-globe"></i>    عام                            </Nav.Link>
                              </Nav.Item>
                              
                              
                              <Nav.Item as="li" className="nav-item btn-group" role="presentation">
                                <Nav.Link as="button" eventKey={'cars'} type="button" className="btn effect mx-2 nav-link" id="pills-home-tab" >
                                <i class="fa-solid fa-car"></i>    المركبات                            </Nav.Link>
                              </Nav.Item> 

                                
                              <Nav.Item as="li" className="nav-item btn-group" role="presentation">
                                <Nav.Link as="button" eventKey={'invoices'} type="button" className="btn effect mx-2 nav-link" id="pills-home-tab" >
                                <i class="fa-solid fa-file-invoice-dollar"></i>     الفواتير                                                </Nav.Link>
                              </Nav.Item>
                            </Nav>

                          </div>

                        </div>
                      </div>
                      {/** Single Message */}


                      <Tab.Content>
                      
                     
                        <Tab.Pane eventKey={activeTab}>
                          <div className="row mt-2">
                                       
 
                          
                                  <div className="col-xl-6 col-xxl-6 col-md-6 col-sm-6">
                                    <div className="card">
                                    <div className="modal-header">
                    <h1 className="modal-title fs-5"> السيارات  </h1>
                    <button type="button" style={{float :"left"}}></button>
                    <i class="fa-solid fa-up-right-from-square"></i>                </div>

                         
                        <div className="card-body py-0 pb-3">
                            
                        <ul className="sociallinks " style={{ direction: 'ltr', maxHeight: '200px', overflowY: 'auto'  }}>
  {/* Check if `orders` has vehicles and map through them */}
  {orders?.vehicles?.length > 0 ? (
    orders.vehicles.map((item, ind) => (
      <li className="d-flex" key={ind}>
        <div className="icon">
          <i className="fa-solid fa-car-side fa-xl"></i>
        </div>
        <div className="d-flex flex-wrap align-items-center justify-content-between w-100">
          <div className="ms-2">
            {/* Render EngineNumber and Color */}
            <Link to={`/car/${item.VehicleID}`} style={{ color: '#C81919',
  textDecoration: 'underline' }}>
                        <h6 className="mb-0"> 
                        
      
        {item.make.MakeName	 ? `${item.make.MakeName} ` : ''} -
        {item.vehicle_model.ModelName	 ? `${item.vehicle_model.ModelName}` : ''} -
         {item.LicensePlate ? `${item.LicensePlate} ` : ''}-
        {item.EngineNumber ? `${item.EngineNumber}` : ''}
       </h6>
</Link>
          </div>
          <div className="d-flex align-items-center">
            {/* Render any additional data, e.g., price */}
            <span className="font-w500 text-primary">{item.Color || 'Unknown Color'}</span>
          </div>
        </div>
      </li>
    ))
  ) : (
    <li>No vehicles available.</li> /* Render a fallback message if no vehicles are present */
  )}
  
</ul>
  
                        </div>   
                   
    
                                        <div className="col-lg-12">

                                          <div className="col-sm-12">
                                            <div className="new-arrival-content text-center ">
                                              <h5>
                                                <span className="" > </span> </h5>
                                            </div>
                                          </div>

                                          <div className="col-sm-12">

                                            <div className="new-arrival-content text-center ">

                                              <h4> <span className="price" > </span> </h4>
                                            </div> </div>






                                        </div>
                                    </div>

                                  </div>
                                  <div className="col-xl-6 col-xxl-6 col-md-6 col-sm-6">
                                    <div className="card">
                                    <div className="modal-header">
                    <h1 className="modal-title fs-5"> الفواتير  </h1>
                    
                            </div>

                         
                        <div className="card-body py-0 pb-3">
                      
        <ul className="sociallinks" style={{ direction: 'ltr',maxHeight: '200px', overflowY: 'auto'  }}>
  {invoices && invoices.length > 0 ? (
    invoices.slice(0, 3).map((item, ind) => (
      <li className="d-flex" key={ind}>
        {/* Icon Section */}
        <div className="icon">
        <i class="fas fa-file-invoice-dollar  fa-xl"></i>
         </div>
        
        {/* Invoice Details Section */}
        <div className="d-flex flex-wrap align-items-center justify-content-between w-100">
          <div className="ms-2">
            <h6 className="mb-0">{item.IssueDate}</h6>
            <small>${Number(item.AmountDue).toFixed(2)}</small>
          </div>
          
          {/* Payment Status Section */}
          <div className="d-flex align-items-center">
            <span className={`font-w500 ${item.PaymentStatus === 'Paid' ? 'text-success' : 'text-primary'}`}>
              {item.PaymentStatus}
            </span>
          </div>
        </div>
      </li>
    ))
  ) : (
    <li className="text-center w-100">
      <span>No invoices available</span>
    </li>
  )}
</ul>

                        </div>   
                   
    
                                        <div className="col-lg-12">

                                          <div className="col-sm-12">
                                            <div className="new-arrival-content text-center ">
                                              <h5>
                                                <span className="" > </span> </h5>
                                            </div>
                                          </div>

                                          <div className="col-sm-12">

                                            <div className="new-arrival-content text-center ">

                                              <h4> <span className="price" > </span> </h4>
                                            </div> </div>






                                        </div>
                                    </div>

                                  </div>
                          </div>

                        </Tab.Pane>
                        <Tab.Pane eventKey={'cars'}>
                      <Cars    orders={orders.vehicles}                  />
                       
                  

                        </Tab.Pane>
                        <Tab.Pane eventKey={'invoices'}>
                        <div className="table-responsive active-projects dlab-scroll task-table my-2 mx-2" style={{  height: "400px" }}>
                                <table className="table">
                                <thead style={{ position: "sticky", top: 0,  zIndex: 1 ,color:'black'}}>                <tr>
                         <th>رقم الفاتورة</th>
                         <th>السيارة</th>
                        <th>القيمة</th>
                        <th>تاريخ الدفع</th>
                        <th>البند</th>

                  </tr>
            </thead>
            <tbody style={{color:'black'}}>
            {invoices.length > 0 ? (
                        invoices.map((invoice) => (
                            <tr
                                key={invoice.InvoiceID}
                                style={{
                                    backgroundColor: colorMap[invoice.RepairOrderID] || "white",
                                }}
                            >
                                <td>{invoice.InvoiceNumber}</td>
                                <td>{invoice.Vehicle.MakeName}-{invoice.Vehicle.ModelName}    -{invoice.Vehicle.EngineNumber}-{invoice.Vehicle.LicensePlate}</td>
                                <td>{invoice.AmountDue }</td>
                                <td>{invoice.IssueDate}</td>
                                <td>{invoice.PaymentStatus}</td>


                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="5" style={{ textAlign: "center" }}>
                              لا توجد فواتير.
                            </td>
                        </tr>
                    )}
                </tbody>
 
        </table>
        </div>

                       
                  

                        </Tab.Pane>
                      </Tab.Content>

                    </Tab.Container>
                  </div>
                </div>
               
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>


  
    
  </>
  );
});

export default Orders;
